<template>
  <div class="jinji">
    <el-tag v-for="tag in dynamicTags" :key="tag.id" size="medium"  :disable-transitions="false" @close="handleClose(tag)">
      {{ tag.name }}
    </el-tag>
    <el-select
      v-if="inputVisible"
      ref="saveTagInput"
      v-model="inputValue"
      filterable
      class="form-item max-154"
      style="margin-left: 10px;"
      placeholder="請選擇"
      @change="handleInputConfirm"
    >
      <el-option v-for="item in Tags" :key="item.id" :label="item.name" :value="item" />
    </el-select>
<!--    <el-cascader-->
<!--      v-if="inputVisible"-->
<!--      ref="saveTagInput"-->
<!--      v-model="inputValue"-->
<!--      style="width:200px;margin-left: 10px; height:35px "-->
<!--      :options="options"-->
<!--      :props="props"-->
<!--      collapse-tags-->
<!--      clearable-->
<!--      filterable-->
<!--      @visible-change="handleInputConfirm"-->
<!--    />-->

    <el-button v-else class="button-new-tag btn" @click="showInput" :disabled="disadled">新增禁忌 +</el-button>
  </div>
</template>
<script>
import { tabooSelect, tabooGroupList } from '@/api/index'
export default {
  model: {
    prop: 'modelvalue',
    event: 'change'
  },
  props: {
    type: {
      type: Number,
      default: 1
    },
    modelvalue: {
      type: Array,
      default: () => []
    },
    disadled: {
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      dynamicTags: [
      ],
      Tags: [

      ],
      inputVisible: false,
      inputValue: '',
      props: { multiple: true },
      options: []
    }
  },
  created() {
    this.tabooSelect(1)
    // this.tabooList()
  },
  methods: {
    tabooList() {
      tabooGroupList({ category_id: this.type }).then(response => {
        this.options = []
        response.data.list.forEach(item => {
          const children = []
          item.taboo.forEach(it => {
            const childer = {
              value: it.id,
              label: it.name
            }
            children.push(childer)
          })
          const obj = {
            label: item.name,
            value: item.id,
            children
          }
          this.options.push(obj)
        })
      })
    },
    tabooSelect(i) {
      if (i == 1) {
        tabooSelect().then(response => {
          this.Tags = response.data.list
          console.log('aaaa',this.modelvalue)
          if (this.modelvalue) {
            this.dynamicTags = this.Tags.filter(item => this.modelvalue.find(it => it == item.id))
          }
        })
      } else {
        tabooSelect({ category_id: this.type }).then(response => {
          this.Tags = response.data.list
        })
      }
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
      const arr = []
      this.dynamicTags.forEach(item => {
        arr.push(item.id)
      })
      this.$emit('change', arr)
    },

    showInput() {
      this.inputVisible = true
      this.tabooSelect()
    },

    handleInputConfirm(callback) {
      if (!callback) {
        const inputValue = this.inputValue
        if (inputValue) {
          inputValue.forEach(item => {
            if (!this.dynamicTags.find(it => it.id == item[1])) {
              const obj = {
                id: item[1],
                name: this.Tags.find(it => it.id == item[1]).name
              }
              this.dynamicTags.push(obj)
            }
          })
        }
        this.inputVisible = false
        this.inputValue = ''
        const arr = []
        this.dynamicTags.forEach(item => {
          arr.push(item.id)
        })
        this.$emit('change', arr)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.jinji{
    min-height: 100px;
    width: 100%;
    border: 1px solid #C0C4CC;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;

}
.el-select{
  width: 150px;
}
.el-tag{
    margin-left: 10px;
    color: #000000;
    background: transparent;
    border-color: #000000;
  margin-bottom: 10px;
}
::v-deep .el-tag .el-tag__close{
    color: #000000;
}
::v-deep .el-tag .el-tag__close:hover{
    background-color: transparent;
    color: #DBBD80;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    border-radius: 5px;
}

.button-new-tag:hover{
    color: #DBBD80;
    border-color:#DBBD80;
    background-color: transparent;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
</style>
